import { JSX, createContext, useState } from 'react';
import { LocalStorageKeys } from '../actions/enums';

export const RedirectContext = createContext(
  {} as {
    signUpRedirect: boolean;
    loginRedirect: boolean;
  },
);

export interface RedirectProviderProps {
  children: JSX.Element;
}

function getAndDestroyLocalStorageFlag() {
  const signUpRedirect = localStorage.getItem(LocalStorageKeys.SIGNED_UP_WITH_REDIRECT) === 'true';
  localStorage.removeItem(LocalStorageKeys.SIGNED_UP_WITH_REDIRECT);

  const loginRedirect = localStorage.getItem(LocalStorageKeys.LOGGED_IN_WITH_REDIRECT) === 'true';
  localStorage.removeItem(LocalStorageKeys.LOGGED_IN_WITH_REDIRECT);

  return {
    signUpRedirect,
    loginRedirect,
  };
}

export const RedirectProvider = (props: RedirectProviderProps) => {
  const { children } = props;
  const [redirects] = useState(getAndDestroyLocalStorageFlag());
  return <RedirectContext.Provider value={redirects}>{children}</RedirectContext.Provider>;
};
